export default __webpack_public_path__ + "locales/vi/InfoPanel.json?hash=2ff48753be3832f9aeceacc7729880f0";